import {
  NavigationItemType,
  NavigationConfig,
  NavigationItemWithComponent,
  NavigationItemWithSubItems,
} from '../types';

// Types for route matching result
export interface RouteMatchResult {
  matchedItem: NavigationItemType | null;
  matchedSecondaryItem: string | null;
}

// Helper function to check if an item has sub-items
export const hasSubItems = (item: NavigationItemType): item is NavigationItemWithSubItems => {
  return 'subItems' in item && Array.isArray(item.subItems) && item.subItems.length > 0;
};

export const hasEmptyState = (item: NavigationItemType): item is NavigationItemWithSubItems => {
  return 'emptyState' in item && item.emptyState !== undefined;
};

export const hasSubComponent = (item: NavigationItemType): item is NavigationItemWithComponent => {
  return 'subComponent' in item && item.subComponent !== undefined;
};

// Utility function to find matching navigation items based on current path
export const findMatchingNavigationItems = (pathname: string, navigationConfig: NavigationConfig): RouteMatchResult => {
  let matchedItem: NavigationItemType | null = null;
  let matchedSecondaryItem: string | null = null;

  navigationConfig.items.forEach((item: NavigationItemType) => {
    // Check for exact match first
    if (item.path && pathname === item.path) {
      matchedItem = item;
      return;
    }

    // Check if current path starts with item path (for sub-routes)
    if (item.path && pathname.startsWith(`${item.path}/`)) {
      matchedItem = item;

      // Check if any sub-item matches the current path
      if (hasSubItems(item) && item.subItems) {
        const matchedSubItem = item.subItems.find((subItem) => subItem.path && pathname === subItem.path);
        if (matchedSubItem) {
          matchedSecondaryItem = matchedSubItem.id;
        }
      }
    }
  });

  return { matchedItem, matchedSecondaryItem };
};
